<template>
  <v-list-item
    v-if="selectedTab === '2' ? isAllocated : true"
    class="classes-list-agenda-item"
    v-bind:class="{
      ...freeTime.class,
      'class-confirmed': isAllocated && allocatedClass,
      'class-canceled': isCanceled && !isAllocated
    }"
    @click="
      freeTime.freeTime
        ? $emit('clicked', {
            freeTime,
            hour,
            date,
            isAllocated,
            isCanceled,
            allocatedClass
          })
        : false
    "
  >
    <div class="classes-list-agenda-color" />
    <div class="classes-list-agenda-time" style="">{{ hour }}:00</div>
    <v-list-item-content v-if="!freeTime.freeTime">
      <v-list-item-title class="classes-list-agenda-title"
        >- -</v-list-item-title
      >
    </v-list-item-content>
    <v-list-item-content v-else-if="isAllocated && allocatedClass">
      <v-list-item-title class="classes-list-agenda-title"
        ><span>• {{ allocatedClass ? allocatedClass.student_profile.name : 'DESMARCADO' }}</span></v-list-item-title>
      <v-list-item-subtitle class="classes-list-agenda-subtitle"
        >{{ allocatedClass.classroom_id ? getClassroomById(allocatedClass.classroom_id).name : 'Homeschool' }}</v-list-item-subtitle
      >
    </v-list-item-content>
    <v-list-item-content v-else-if="isAllocated && !allocatedClass">
      <v-list-item-title class="classes-list-agenda-title"
        >Horário desmarcado</v-list-item-title
      >
      <v-list-item-subtitle class="classes-list-agenda-subtitle"
        >Este horário está indisponível</v-list-item-subtitle
      >
    </v-list-item-content>
    <v-list-item-content v-else-if="isCanceled && !isAllocated">
      <v-list-item-title class="classes-list-agenda-title"
        >Aula cancelada</v-list-item-title
      >
      <v-list-item-subtitle class="classes-list-agenda-subtitle"
        >Este horário está novamente vago</v-list-item-subtitle
      >
    </v-list-item-content>
    <v-list-item-content v-else-if="!isAllocated">
      <v-list-item-title class="classes-list-agenda-title">
        Horário disponível <span>• </span></v-list-item-title
      >
    </v-list-item-content>
    <v-list-item-content v-else-if="isAllocated">
      <v-list-item-title class="classes-list-agenda-title"
        >{{ allocatedClass.classroom.name }}
        <span>• {{ allocatedClass ? allocatedClass.student_profile.name : 'DESMARCADO'}}</span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    freeTime: Object,
    hour: String,
    date: Date,
    selectedTab: String,
  },
  computed: {
    allocatedClass() {
      if (!this.freeTime.freeTime) return {};
      return this.getAllocatedClassById(
        this.freeTime.freeTime.id,
        this.parsedDate,
        this.hour
      );
    },
    ...mapState(["allocatedClasses", "classrooms", "userProfile"]),
    ...mapGetters([
      "getClassroomById",
      "getAllocatedClassById",
      "getCancelledClass"
    ]),
    parsedDate() {
      const splitParsedDate = this.date.toLocaleDateString('en-US').split("/")
      const parsedDate = `${splitParsedDate[2]}-${splitParsedDate[0].padStart(2, '0')}-${splitParsedDate[1].padStart(2, '0')}`

      return parsedDate;
    },
    isAllocated() {
      if (!this.freeTime.freeTime) return false;

      return this.freeTime.freeTime.allocated_dates.includes(
        `${this.parsedDate}T${this.hour}`
      );
    },
    isCanceled() {
      if (!this.freeTime.freeTime) return false;

      return this.getCancelledClass(
        this.freeTime.freeTime.id,
        this.parsedDate,
        this.hour
      );
    }
  },
};
</script>

<style scoped>
.teacher-app-bg {
  /* font-family: "Montserrat", sans-serif; */
  font-family: 'Poppins', sans-serif;
  margin: 0 auto;
  padding-bottom: 90px;
  background: rgba(244, 244, 252, 1);
  background: -moz-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(244, 244, 252, 1)),
    color-stop(100%, rgba(240, 240, 250, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(243, 243, 251, 11) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f4f4fc', endColorstr='#f0f0fa', GradientType=0 );
}

.logo-navbar {
  height: 90%;
}

.header-do-perfil {
  padding: 16px 20px 46px;
  background-color: #350078;
}
.foto-do-perfil {
  height: 100%;
  width: 100%;
  background-image: url("../../assets_aluno/galileo_3.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 2px solid #ffffff;
}
p.nome-do-aluno {
  color: #44ff99;
  text-transform: uppercase;
  font-weight: 900;
  margin-bottom: 0;
  padding-left: 16px;
}
p.dados-do-aluno {
  line-height: 2;
  color: #ffffff;
  font-size: 11px;
  margin: 0;
  font-weight: 700;
  padding-left: 16px;
}

.agenda-day {
  padding: 80px 32px 18px;
}
.agenda-title {
  font-size: 13px;
  text-align: center;
  text-transform: uppercase;
  color: #440099;
  letter-spacing: 7px;
  font-style: italic;
  margin-bottom: 64px;
  font-weight: 400;
}
.agenda-day-title {
  text-align: center;
  text-transform: uppercase;
  color: #440099;
  font-weight: 900;
  font-size: 38px;
  line-height: 1.1;
}
.agenda-day-title span {
  font-weight: 400;
  font-style: italic;
}
.agenda-day-arrow {
  width: 30px;
  color: #32e382;
}
.agenda-day-arrow.arrow-disabled {
  color: #d1c8de;
}

.btn-toggle-purple >>> .v-btn {
  font-weight: 700;
  color: #a09aab;
  border: 1px solid #440099 !important;
  font-size: 11px;
  height: 42px;
}
.btn-toggle-purple >>> .v-btn.v-item--active.v-btn--active {
  border: 1px solid #440099 !important;
  color: #440099;
  transition: 0.2s;
}
.btn-toggle-purple >>> .v-btn.v-item--active.v-btn--active::before {
  opacity: 0;
}

.agenda-day-subtitle {
  text-align: center;
  color: #a09aab;
  font-weight: 400;
  font-size: 13px;
  margin: 0 auto 18px;
  text-transform: uppercase;
}
.classes-list-agenda {
  padding: 32px;
  position: relative;
}
.classes-list-agenda-card {
  width: 100%;
  position: relative;
  display: inline;
  box-shadow: 0 3px 12px 1px rgba(10, 5, 18, 0.1);
}
.classes-list-agenda-item {
  padding-left: 0;
  border-bottom: 1px solid #f0f0f0;
  min-height: 64px;
}
.classes-list-agenda-color {
  position: absolute;
  width: 6px;
  height: 100%;
  background-color: #e2dfe8;
}
.classes-list-agenda-time {
  display: inline-flex;
  min-width: 80px;
  width: 80px;
  padding: 0 9px 0 21px;

  font-weight: 700;
  color: #c2bfc7;
  text-align: center;
}
.classes-list-agenda-title {
  color: #a09aab;
  font-weight: 400;
  text-transform: none;
}
.classes-list-agenda-title span {
  font-weight: 400;
  color: #a09aab;
  text-transform: capitalize;
}
.v-list-item__subtitle.classes-list-agenda-subtitle {
  color: #a09aab;
  font-weight: 400;
  font-size: 13px;
  font-style: italic;
}

.classes-list-agenda-item.class-confirmed div.classes-list-agenda-color {
  background-color: #44ff99;
}
.classes-list-agenda-item.class-confirmed div.classes-list-agenda-time {
  color: #440099;
}
.classes-list-agenda-item.class-confirmed
  div.v-list-item__title.classes-list-agenda-title {
  color: #440099;
  font-weight: 700;
  text-transform: uppercase;
}
.classes-list-agenda-item.class-confirmed
  div.v-list-item__title.classes-list-agenda-title
  span {
  color: #440099;
}

.classes-list-agenda-item.class-impossible {
  background-color: #f4f3f5;
}
.classes-list-agenda-item.class-impossible:active {
  background-color: #fafafa;
}
.classes-list-agenda-item.class-impossible div.classes-list-agenda-color {
  background-color: #c2bfc7;
}
.classes-list-agenda-item.class-impossible div.classes-list-agenda-time {
  color: #c2bfc7;
}
.classes-list-agenda-item.class-impossible
  div.v-list-item__title.classes-list-agenda-title {
  color: #c2bfc7;
  font-weight: 400;
}
.classes-list-agenda-item.class-impossible
  div.v-list-item__title.classes-list-agenda-title
  span {
  color: #c2bfc7;
}
.classes-list-agenda-item.class-canceled div.classes-list-agenda-color {
  background-color: #ff3d00;
}
.classes-list-agenda-item.class-canceled div.classes-list-agenda-time {
  color: #ff3d00;
}
.classes-list-agenda-item.class-canceled
  div.v-list-item__title.classes-list-agenda-title {
  color: #ff3d00;
  font-weight: 400;
}
.classes-list-agenda-item.class-canceled
  div.v-list-item__title.classes-list-agenda-title
  span {
  color: #c2bfc7;
}
</style>
